module.exports = __webpack_public_path__ + "static/media/gr.a69193c3.svg";